var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2427 11.5757L8 15.8183L3.75736 11.5757C1.41421 9.23248 1.41421 5.43352 3.75736 3.09037C6.10051 0.747221 9.89947 0.747221 12.2427 3.09037C14.5858 5.43352 14.5858 9.23248 12.2427 11.5757ZM8 9.99968C9.47273 9.99968 10.6667 8.80574 10.6667 7.33301C10.6667 5.86025 9.47273 4.66634 8 4.66634C6.52724 4.66634 5.33333 5.86025 5.33333 7.33301C5.33333 8.80574 6.52724 9.99968 8 9.99968ZM8 8.66634C7.2636 8.66634 6.66667 8.06941 6.66667 7.33301C6.66667 6.59663 7.2636 5.99967 8 5.99967C8.7364 5.99967 9.33333 6.59663 9.33333 7.33301C9.33333 8.06941 8.7364 8.66634 8 8.66634Z",
    fill: "#FF0400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapicon);
export default __webpack_public_path__ + "static/media/mapicon.0f14216dfd9954d51d20f1bc0ffb5a2a.svg";
export { ForwardRef as ReactComponent };